<template>
  <v-container pa-0>
    <!-- <v-app-bar flat style=" padding-left:20px;">
      <v-icon class="ml-1">mdi-account-group</v-icon>
      <v-toolbar-title class="ml-1">
        <b style="font-size:0.8em;">Contatos</b>
      </v-toolbar-title>
    </v-app-bar>-->
    <v-main style="height:80vh;">
      <v-container fluid pt-0>
        <v-row>
          <v-col cols="12" style="padding-top:0; padding-left:20px;">
            <v-text-field label="Pesquisar contatos" v-model="input"></v-text-field>

            <!-- <input class="form-control wa-input" v-model="input" placeholder="Pesquisar contatos" /> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-list shaped subheader>
              <v-list-item-group v-model="item" color="#000">
                <div v-if="filtroClientes && filtroClientes !== null && filtroClientes.length > 0">
                  <v-virtual-scroll
                    :items="filtroClientes"
                    :item-height="100"
                    :height="windowHeight"
                  >
                    <template v-slot="{item}">
                      <v-list-item @click="selectCliente(item)">
                        <v-list-item-avatar color="grey" class="userimage">
                          <!-- <v-img :src="`http://${ip}/gravacoes/clientes/${item.id}.jpg`"></v-img> -->
                        </v-list-item-avatar>

                        <v-list-item-content style="border-bottom:1px #ededed solid;">
                          <v-list-item-title v-text="item.nome"></v-list-item-title>
                          <v-list-item-subtitle v-html="item.numero"></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-icon>
                          <div style="display:flex; flex-direction:column">
                            <!-- <span style="flex:1;" v-if="item.lastMsg">{{formataHora(item.lastMsg.dataHora)}}</span>
                    <span style="flex:1;" v-if="!item.lastMsg">{{formataHora(item.dataIni)}}</span>
                            <v-badge style="flex:1;" color="#09d261" content="54" inline="true"></v-badge>-->
                            <!-- <span style="flex:1;" class="badge badge-pill wa-badge">54</span> -->
                          </div>
                        </v-list-item-icon>
                      </v-list-item>
                    </template>
                  </v-virtual-scroll>
                </div>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-container>
</template>
   
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("xc");
import moment from "moment";
import filter from "../plugins/Filter";
import { debounce } from "../plugins/Debounce";

export default {
  name: "ListaClientes",
  data: () => ({
    ip: JSON.parse(localStorage.getItem("config")).servidor,
    whatsForm: {
      numero: null,
      queue: null,
      instancia: null,
      nome: null,
    },
    search: null,
    item: null,
    input: null,
    windowHeight: 0,
    totalHeight: 0,
  }),
  watch: {
    input: debounce(function (newVal) {
      this.search = newVal;
    }, 500),
  },
  computed: {
    ...mapState({
      clientes: (state) => state.clientes,
    }),
    user: function () {
      return this.$store.state.auth.user;
    },
    filtroClientes: function () {
      if (!this.clientes && this.clientes === null) return null;
      if (this.search && this.search.length > 0) {
        let prop = Object.keys(this.clientes[0]);
        return filter.transform(this.clientes, this.search, prop);
      } else {
        return this.clientes;
      }
    },
  },
  created() {
    this.getClientes();
    this.calcHeight();
    window.addEventListener("resize", () => {
      this.calcHeight();
      //this.windowHeight = window.innerHeight
    });
  },
  methods: {
    ...mapActions([
      "addAtendimento",
      "selectCliente",
      "getDefault",
      "newWhatsApp",
    ]),
    abrirChat(index) {
      this.selectAtendimento(index);
    },
    formataHora(dataHora) {
      return moment(dataHora).format("HH:mm");
    },
    async getClientes() {
      try {
        let clientes = await this.getDefault("/api/v2/clientes?max=-1&page=1");
        this.clientes = clientes;
      } catch (error) {
        console.error(error);
      }
    },
    async getFilas() {
      try {
        let retorno = await this.getDefault("/api/v3/fila?max=-1&page=1");
        return retorno.dados;
      } catch (error) {
        console.error(error);
      }
    },
    calcHeight() {
      this.totalHeight = window.innerHeight;
      this.windowHeight = window.innerHeight * (65 / 100);
    },
  },
  mounted() {},
};
</script>

<style>
</style>